import { findMessageNodeById } from './findMessageNodeById';

export enum MessageContentType {
  Text = 'text',
}

export const MESSAGE_CONTENT_TYPE_ATTRIBUTE = 'data-message-content-type';

export function findMessageContentNode(
  messageId: string,
  type: MessageContentType
): HTMLElement | null {
  return (
    findMessageNodeById(messageId)?.querySelector(`[${MESSAGE_CONTENT_TYPE_ATTRIBUTE}=${type}]`) ||
    null
  );
}
